import React, { useEffect, useState } from 'react';
import '../../Assets/CSS/EmployeeInfoCard.css';
import axios from 'axios';
import LightText, { BigText, LightDark } from '../../Assets/CSS/Text';
import { capitalize } from '@mui/material';
import { Icon } from '@iconify/react/dist/iconify.js';
import { useNavigate } from 'react-router-dom';
import Skeleton from "react-loading-skeleton";
import "react-loading-skeleton/dist/skeleton.css";

const EmployeeInfo = ({ empId }) => {
    const [employee, setEmployee] = useState(null);
    const navigate = useNavigate();

    useEffect(() => {
        featchemployeeDetail();
    }, []);

    const featchemployeeDetail = async () => {
        try {
            const token = localStorage.getItem("token");
            const response = await axios.get(
                `${process.env.REACT_APP_BACKEND_URL}/api/v1/emps/${empId}`,
                {
                    headers: {
                        Authorization: `Bearer ${token}`,
                    },
                }
            );
            console.log("Employee API response:", response.data);
            setEmployee(response.data);
        } catch (error) {
            console.error("Error fetching employee details:", error);
        }
    };

    return (
        <div className="container">
            <div className="d-flex align-item-center gap-2 mt-5 ">
                <Icon icon='ic:round-arrow-back'
                    onClick={() => {
                        navigate(-1);
                    }} className='mt-1 fs-5' 
                    style={{cursor:'pointer'}}/>
                <h5 style={BigText}>Employee Profile View</h5>
            </div>

            <div
                className="p-4 border employee-Info rounded-2 "
                style={{ boxShadow: '0px 4px 20px 0px #00000012' }}
            >
                {employee ? (
                    <div className="row align-items-center">
                        {/* Profile Photo and Basic Info */}

                        <div className="col-md-4 text-center mb-3 d-flex flex-column align-items-center">
                            <div className="profile-Image mb-2">
                                {/* <img
                                    src={require("../../Assets/Images/man.png")}
                                    // src={employee.empPhoto}
                                    alt="Employee"
                                    className="w-100 h-100 rounded-circle"
                                /> */}
                                <div
                                    className=" w-100 h-100 rounded-circle rounded-circle d-flex justify-content-center align-items-center"
                                    style={{
                                        width: "36px",
                                        height: "36px",
                                        fontSize: "12px",
                                        color: "#999",
                                        backgroundColor: "#F0F0F0",
                                        border: "1px solid #F0F0F0 ",
                                        
                                    }}
                                >
                                    <Icon
                                        icon="proicons:person"
                                        className="fs-1 "
                                        style={{}}
                                    />
                                </div>
                            </div>

                            <h5 className="mb-1">
                                {capitalize(employee.firstName)} {capitalize(employee.middleName || "")} {capitalize(employee.lastName)}
                            </h5>
                            <small style={LightText} className="pt-1 text-muted">
                                {capitalize(employee.designation)} &nbsp;|&nbsp; {employee.departmentName?.toUpperCase()}
                            </small>
                        </div>


                        {/* Employee Details */}
                        <div className="col-md-8">
                            <div className="row">
                                <div className="col-sm-6">
                                    <p style={LightText}>Employee ID:<span style={LightDark}>{employee.empId}</span></p>
                                    <p style={LightText}>Personal Email:<span style={LightDark}>{employee.personalEmail}</span></p>
                                    <p style={LightText}>Mobile Number: <span style={LightDark}>{employee.mobileNumber}</span></p>
                                    <p style={LightText}>Date of Birth:<span style={LightDark}>{employee.dateOfBirth}</span> </p>
                                </div>
                                <div className="col-sm-6">
                                    <p style={LightText}>Office Email: <span style={LightDark}>{employee.officeEmail}</span></p>
                                    <p style={LightText}>Date of Joining: <span style={LightDark}>{employee.dateOfJoining}</span></p>
                                    <p style={LightText}>Manager Name: <span style={LightDark}>{employee.managerName}</span></p>
                                    <p style={LightText}>Tenant: <span style={LightDark}>{employee.tenantName}</span></p>
                                </div>
                            </div>
                        </div>
                    </div>
                ) : (
          // 🔹 Skeleton Loader
          <div className="row align-items-center">
            <div className="col-md-4 text-center mb-3 d-flex flex-column align-items-center">
              <Skeleton circle width={80} height={80} />
              <h5 className="mb-1 mt-2">
                <Skeleton width={120} />
              </h5>
              <small className="pt-1 text-muted">
                <Skeleton width={150} />
              </small>
            </div>
            <div className="col-md-8">
              <div className="row">
                <div className="col-sm-6">
                  <p>
                    <Skeleton width={200} />
                  </p>
                  <p>
                    <Skeleton width={180} />
                  </p>
                  <p>
                    <Skeleton width={160} />
                  </p>
                </div>
                <div className="col-sm-6">
                  <p>
                    <Skeleton width={200} />
                  </p>
                  <p>
                    <Skeleton width={180} />
                  </p>
                  <p>
                    <Skeleton width={160} />
                  </p>
                </div>
              </div>
            </div>
          </div>
        )}
            </div>
        </div>
    );
};

export default EmployeeInfo;

